
<section class="download-app-section">
  <div class="download-content">
    <div class="app-info">
      <img src="assets/app-icon-transparent.png" alt="App Icon" class="app-icon">
      <div class="app-text">
        <h2>Download Our App</h2>
        <p>Experience the best of Tune Me on your mobile device.</p>
      </div>
    </div>
    <a href="https://play.google.com/store/apps/details?id=org.unfpa.mhsp.tuneme" target="_blank" class="download-button">
      <img src="assets/google-play-icon.png" alt="Google Play Store" class="play-store-icon">
      Download App – Tune Me
    </a>
    <p class="trademark-disclaimer">
      Google Play and the Google Play logo are trademarks of Google LLC.
    </p>
  </div>
</section>
